import { render, staticRenderFns } from "./DeclarationLTCATPP.vue?vue&type=template&id=75c204bc"
import script from "./DeclarationLTCATPP.vue?vue&type=script&lang=js"
export * from "./DeclarationLTCATPP.vue?vue&type=script&lang=js"
import style0 from "./DeclarationLTCATPP.vue?vue&type=style&index=0&id=75c204bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports